// extracted by mini-css-extract-plugin
module.exports = {"modal":"_1l2dLzmAv4iY_W7iZZN488"};